import { moduleNames } from 'pages/Stores/components/modules';
import { createArtistsModule } from './moduleTypes/artists';
import { createBannerModule } from './moduleTypes/banner';
import { createFavoriteProductsModule } from './moduleTypes/favoriteProducts';
import { createEventsModule } from './moduleTypes/events';
import { createLocationsModule } from './moduleTypes/locations';
import { createLooksModule } from './moduleTypes/looks';
import { createVideoModule } from './moduleTypes/video';

export const pageModuleTypes = {
  [moduleNames.MULTIPLE_LOOK]: createLooksModule,
  [moduleNames.FAVORITE_PRODUCTS]: createFavoriteProductsModule,
  [moduleNames.BANNER]: createBannerModule,
  [moduleNames.VIDEO]: createVideoModule,
  [moduleNames.ARTISTS]: createArtistsModule,
  [moduleNames.LOCATIONS]: createLocationsModule,
  [moduleNames.EVENTS]: createEventsModule,
};

export const pageModuleTypeKeys = {
  look: moduleNames.MULTIPLE_LOOK,
  looks: moduleNames.MULTIPLE_LOOK,
  favorite_product: moduleNames.FAVORITE_PRODUCTS,
  favorite_products: moduleNames.FAVORITE_PRODUCTS,
  banner: moduleNames.BANNER,
  video: moduleNames.VIDEO,
  participants: moduleNames.ARTISTS,
  artists: moduleNames.ARTISTS,
  locations: moduleNames.LOCATIONS,
  events: moduleNames.EVENTS,
};
